import axios from 'axios'
import {
  getSavedState,
  saveState,
  setDefaultAuthHeaders,
  setDefaultAxiosInterceptors,
} from '../store-utils'

export const state = {
  currentUser: getSavedState('auth.currentUser'),
  currentUserId: null,
  currentUserToken: getSavedState('auth.currentUserToken'),
}

export const mutations = {
  SET_CURRENT_USER_TOKEN(state, newValue) {
    state.currentUserToken = newValue
    saveState('auth.currentUserToken', newValue)
    setDefaultAuthHeaders(state)
  },

  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
    state.currentUserId = newValue.user.id
    saveState('auth.currentUser', newValue)
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedInToken(state) {
    return state.currentUserToken
  },
  loggedInUser(state) {
    return state.currentUser
  },
  currentUserId(state) {
    return state.currentUserId
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
    setDefaultAxiosInterceptors()
    dispatch('validate')
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { userNameOrEmailAddress, password } = {}) {
    if (getters.loggedIn && getters.loggedInUser) return dispatch('validate')

    return axios
      .post('/api/TokenAuth/Authenticate', {
        userNameOrEmailAddress,
        password,
      })
      .then((response) => {
        const user = response.data
        commit('SET_CURRENT_USER_TOKEN', user)
        dispatch('validate')
        return user
      })
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('SET_CURRENT_USER', null)
    commit('SET_CURRENT_USER_TOKEN', null)
  },

  updatePassword({ commit }, { password }) {
    return axios.post('/api/services/app/User/ChangePassword', password)
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state }) {
    if (!state.currentUserToken) return Promise.resolve(null)

    return axios
      .get('/api/services/app/Session/GetCurrentLoginInformations')

      .then((response) => {
        const user = response.data
        commit('SET_CURRENT_USER', user)

        return user
      })

      .catch((error) => {
        if (error.response /* && error.response.status === 401 */) {
          commit('SET_CURRENT_USER', null)
          commit('SET_CURRENT_USER_TOKEN', null)
        }

        return null
      })
  },
}
